import { Row, Text, Title } from '@ydistri/ds';
import { InfoIconTooltip } from '../../../../../components/icons/InfoIconTooltip';
import React from 'react';

interface CategoryInsightsMetricProps {
  formattedValue: string;
  name: string;
  tooltipContent?: React.ReactNode;
}

const CategoryInsightsMetric: React.FC<CategoryInsightsMetricProps> = ({
  formattedValue,
  name,
  tooltipContent,
}) => {
  return (
    <Row
      data-testid={`CategoryInsightsMetric-${name.toLowerCase().replace(/\s+/g, '-')}`}
      $gap="0.5rem"
      $alignItems="center"
      $flexShrink={1}
    >
      <Title $size="small">{formattedValue}</Title>
      <Row $gap="0.5rem" $alignItems="center">
        <Text $size="large">{name}</Text>
        {tooltipContent && <InfoIconTooltip content={tooltipContent} />}
      </Row>
    </Row>
  );
};

export default CategoryInsightsMetric;
